export const appBaseURL = "/n/"

export const appRootId = "nuxt-app"

export const appBuildAssetsDir = "assets"

export const appCdnURL = "https://s5-edu.51cto.com/edu/exam-lib-fe"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"build-date","content":"Fri, 28 Jun 2024 06:21:30 GMT"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"http-equiv":"x-dns-prefetch-control","content":"on"},{"http-equiv":"Content-Type","content":"text/html;charset=utf-8"},{"name":"keywords","content":"计算机软件资格考试,计算机软考试题,软考刷题,软考题库,软考历年试题,软考模拟题,软考章节练习题,计算机技术与软件专业技术资格（水平）考试"},{"name":"description","content":"51CTO题库是IT在线教育专业品牌51CTO学堂旗下，由51CTO学堂软考讲师团队，精心出题、校编解析而打造出的一款软考刷题工具。提供软考(计算机软件资格考试)历年试题、软考模拟题、软考章节练习、软考每日刷题、软考错题集、软考模拟机考平台，PC端/手机移动端随时刷软考题，助力软考备考。"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical","href":"https://t.51cto.com/"},{"rel":"dns-prefetch","href":"https://s5-edu.51cto.com/"}],"style":[],"script":[],"noscript":[],"title":"软考在线做题备考工具-51CTO题库","htmlAttrs":{"lang":"zh-CN","style":""}}

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#nuxt-app'

export const viewTransition = false